import { Menu, UnstyledButton } from '@mantine/core';
// icons
import { EllipsisVertical, Plus } from 'lucide-react';
// utils
import { cn } from '@/utils';

interface ContextMenuProps {
    onAdd: () => void;
    isDisabled: boolean;
}

const ContextMenu = ({ onAdd, isDisabled }: ContextMenuProps) => {
    return (
        <Menu withArrow disabled={isDisabled}>
            <Menu.Target>
                <UnstyledButton
                    className={cn({
                        'opacity-20 pointer-events-none': isDisabled
                    })}
                >
                    <EllipsisVertical />
                </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item leftSection={<Plus />} onClick={onAdd}>
                    Add Attribute
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};

export default ContextMenu;
